export const CIRCULAR_KNITTING_LEG = {
  mainProductLine: "CircularKnitting",
  bodyArea: "Leg",
} as const;
